import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createCollapsableCard } from './CollapsableCard';
import { COLLAPSABLE_CARD_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(COLLAPSABLE_CARD_BASE_CLASSNAME), createCollapsableCard, NO_PATTERN_BUSINESS_LOGIC);
